/**
 * Normalize Latvian text for search purposes
 * Converts special Latvian characters to their plain Latin equivalents
 * This allows users to search without typing diacritical marks
 */
export function normalizeLatvianText(text: string): string {
  const latvianChars: { [key: string]: string } = {
    'ā': 'a',
    'Ā': 'A',
    'č': 'c',
    'Č': 'C',
    'ē': 'e',
    'Ē': 'E',
    'ģ': 'g',
    'Ģ': 'G',
    'ī': 'i',
    'Ī': 'I',
    'ķ': 'k',
    'Ķ': 'K',
    'ļ': 'l',
    'Ļ': 'L',
    'ņ': 'n',
    'Ņ': 'N',
    'š': 's',
    'Š': 'S',
    'ū': 'u',
    'Ū': 'U',
    'ž': 'z',
    'Ž': 'Z'
  };

  return text.replace(/[āĀčČēĒģĢīĪķĶļĻņŅšŠūŪžŽ]/g, char => latvianChars[char] || char);
}

/**
 * Check if a text contains a search term, considering both normalized and original versions
 * @param text - The text to search in
 * @param searchTerm - The search term
 * @returns true if the text contains the search term (with or without diacritics)
 */
export function searchLatvianText(text: string, searchTerm: string): boolean {
  // Convert both to lowercase for case-insensitive search
  const lowerText = text.toLowerCase();
  const lowerSearchTerm = searchTerm.toLowerCase();
  
  // Check if the original text contains the search term
  if (lowerText.includes(lowerSearchTerm)) {
    return true;
  }
  
  // Normalize both text and search term and check again
  const normalizedText = normalizeLatvianText(lowerText);
  const normalizedSearchTerm = normalizeLatvianText(lowerSearchTerm);
  
  return normalizedText.includes(normalizedSearchTerm);
}